module.exports = __webpack_public_path__ + "images/namallianzcc84c55a0b045ba1ad366b8b48d2746e.png";